"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteManager = exports.Link = exports.Router = void 0;
const store_1 = require("client/modules/users/store");
const React = require("react");
const react_1 = require("react");
const logger_1 = require("shared/logger");
const log = new logger_1.Logger("router");
class Router extends react_1.Component {
    constructor() {
        super(...arguments);
        this.component = null;
        this.routes = [];
        this.route = null;
        this.unmounting = false;
        // public componentWillMount = async () => {
        //   await usersStore.checkLoginValid();
        //   RouteManager.addStateListener(this.matchRoutes);
        //   this.matchRoutes();
        // }
        this.componentDidUpdate = async () => {
            await store_1.usersStore.checkLoginValid();
        };
        this.matchRoutes = () => {
            if (this.unmounting)
                return;
            log.debug("matching routes");
            this.route = null;
            for (const route of this.routes) {
                const match = location.pathname.match(route.path);
                if (match) {
                    log.debug("found route", route.path, match);
                    this.component = React.createElement(route.component, { params: match.slice(1) });
                    this.route = route;
                    this.forceUpdate();
                    return;
                }
            }
            log.debug("no routes found");
            this.component = RouteManager.notFoundComponent ? (React.createElement(RouteManager.notFoundComponent, { params: [location.pathname] })) : null;
            this.forceUpdate();
        };
    }
    componentWillMount() {
        RouteManager.addStateListener(this.matchRoutes);
        this.matchRoutes();
    }
    componentWillUnmount() {
        this.unmounting = true;
        RouteManager.removeStateListener(this.matchRoutes);
    }
    addRoute(name, path, component) {
        this.routes.push({ name, path, component });
    }
    removeRoute(path) {
        this.routes = this.routes.filter(route => route.path !== path);
    }
    render() {
        return this.component;
    }
}
exports.Router = Router;
class Link extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            RouteManager.transitionTo(this.props.to);
        };
    }
    render() {
        return React.createElement("a", { onClick: this.onClick }, this.props.children);
    }
}
exports.Link = Link;
window.onpopstate = () => {
    RouteManager.runStateListeners();
};
class RouteManager {
}
exports.RouteManager = RouteManager;
RouteManager.notFoundComponent = null;
RouteManager.stateListeners = [];
RouteManager.setNotFoundComponent = (component) => {
    RouteManager.notFoundComponent = component;
};
RouteManager.transitionTo = (to) => {
    window.history.pushState(null, "", to);
    RouteManager.runStateListeners();
};
RouteManager.addStateListener = (listener) => {
    RouteManager.stateListeners.push(listener);
};
RouteManager.removeStateListener = (listener) => {
    RouteManager.stateListeners = RouteManager.stateListeners.filter(sl => sl !== listener);
};
RouteManager.runStateListeners = () => {
    RouteManager.stateListeners.forEach(sl => sl());
};



//////////////////
// WEBPACK FOOTER
// ./src/client/components/router/router.tsx
// module id = 416
// module chunks = 0 1 2